import { Checkbox } from '@material-ui/core';
import React from 'react';
import {
  SystemSafeIcon,
  SystemSiteIcon,
  SystemFounIcon,
  SystemFrmgIcon,
  SystemThrmIcon,
  SystemAirbIcon,
  SystemDrgpIcon,
  SystemWallIcon,
  SystemShwrIcon,
  SystemRoofIcon,
  SystemHvacIcon,
  SystemPlmbIcon,
  SystemFnshIcon,
  SystemElecIcon,
  SystemApplIcon,
  LotCircleIcon,
} from './PerformIcons';

const iconMap = {
  // name:'Job Site Safety', parentId: NULL
  1: SystemSafeIcon,
  // name:'Site', parentId: NULL
  2: SystemSiteIcon,
  // name:'Foundations', parentId: NULL
  3: SystemFounIcon,
  // name:'Framing', parentId: NULL
  4: SystemFrmgIcon,
  // name:'Thermal Enclosure', parentId: NULL
  5: SystemThrmIcon,
  // name:'Air Barrier', parentId: NULL
  6: SystemAirbIcon,
  // name:'Drainage Plane and Flashing', parentId: NULL
  7: SystemDrgpIcon,
  // name:'Wall Cladding', parentId: NULL
  8: SystemWallIcon,
  // name:'Showers and Tubs', parentId: NULL
  9: SystemShwrIcon,
  // name:'Roof Cladding and Drainage', parentId: NULL
  10: SystemRoofIcon,
  // name:'HVAC Systems', parentId: NULL
  11: SystemHvacIcon,
  // name:'Plumbing and Electrical Systems', parentId: NULL
  12: SystemPlmbIcon,
  // name:'Interior Finishes', parentId: NULL
  13: SystemFnshIcon,
  // name:'Fit and Finish', parentId: NULL
  14: SystemFnshIcon,
  // name:'ENERGY STAR for Home Baseline', parentId: NULL
  15: SystemElecIcon,
  // name:'Envelope', parentId: NULL
  16: SystemAirbIcon,
  // name:'Water Management', parentId: NULL
  17: SystemDrgpIcon,
  // name:'Water Efficiency', parentId: NULL
  18: SystemPlmbIcon,
  // name:'Lighting and Appliances', parentId: NULL
  19: SystemApplIcon,
  // name:'Indoor Air Quality', parentId: NULL
  20: SystemHvacIcon,
  // name:'Renewable Energy', parentId: NULL
  21: SystemElecIcon,
  // name:'Stucco', parentId: '8'
  22: SystemWallIcon,
  // name:'Siding', parentId: '8'
  23: SystemWallIcon,
  // name:'Brick', parentId: '8'
  24: SystemWallIcon,
  // name:'Cultured Stone (Direct Applied)', parentId: '8'
  25: SystemWallIcon,
  // name:'Flooring', parentId: '13'
  26: SystemFnshIcon,
  // name:'Plumbing', parentId: '12'
  27: SystemPlmbIcon,
  // name:'Building Paper', parentId: '7'
  28: SystemDrgpIcon,
  // name:'Housewrap', parentId: '7'
  29: SystemDrgpIcon,
  // name:'Block', parentId: '7'
  30: SystemDrgpIcon,
  // name:'Structural Laminated Sheathing', parentId: '7'
  31: SystemDrgpIcon,
  // name:'Structural Sheathing with WRB', parentId: '7'
  32: SystemDrgpIcon,
  // name:'SWPPP', parentId: '2'
  33: SystemSiteIcon,
  // name:'HVAC-Duct install layout', parentId: '11'
  34: SystemHvacIcon,
  // name:'Home Complete', parentId: '14'
  35: LotCircleIcon,
};

export default function SystemIcon(props) {
  const { systemId, useCheckbox } = props;
  const Icon = iconMap[systemId];

  if (useCheckbox) {
    return <Checkbox {...props} />;
  }

  return !Icon ? null : <Icon {...props} />;
}
